/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Search_None_CtaInputs */

const en_help_search_none_cta = /** @type {(inputs: Help_Search_None_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask us instead`)
};

const pl_help_search_none_cta = /** @type {(inputs: Help_Search_None_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapytaj nas`)
};

/**
* | output |
* | --- |
* | "Ask us instead" |
*
* @param {Help_Search_None_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_search_none_cta = /** @type {((inputs?: Help_Search_None_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Search_None_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_search_none_cta(inputs)
	return en_help_search_none_cta(inputs)
});